export const SEARCH_INSTANCE_STATUS = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  DEACTIVATED: 'Deactivated',
  HOME_PURCHASED: 'HomePurchased',
} as const;
